import { SVGProps } from 'react';

interface CollapseIconProps extends SVGProps<SVGSVGElement> {
  arrowFillColor?: string;
  backgroundFillColor?: string;
}

export const CollapseIcon = (props: CollapseIconProps) => {
  const { arrowFillColor = 'var(text-and-icon)', backgroundFillColor = '#EFEFF1', ...rest } = props;

  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}>
      <rect width='28' height='28' rx='4' fill={backgroundFillColor} />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.8536 19.1464C20.0488 19.3417 20.0488 19.6583 19.8536 19.8536C19.6583 20.0488 19.3417 20.0488 19.1464 19.8536L16.5 17.2071V19C16.5 19.2761 16.2761 19.5 16 19.5C15.7239 19.5 15.5 19.2761 15.5 19V16C15.5 15.7239 15.7239 15.5 16 15.5H19C19.2761 15.5 19.5 15.7239 19.5 16C19.5 16.2761 19.2761 16.5 19 16.5H17.2071L19.8536 19.1464Z'
        fill={arrowFillColor}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.14645 19.8536C7.95118 19.6583 7.95118 19.3417 8.14645 19.1464L10.7929 16.5H9C8.72386 16.5 8.5 16.2761 8.5 16C8.5 15.7239 8.72386 15.5 9 15.5H12C12.2761 15.5 12.5 15.7239 12.5 16V19C12.5 19.2761 12.2761 19.5 12 19.5C11.7239 19.5 11.5 19.2761 11.5 19V17.2071L8.85355 19.8536C8.65829 20.0488 8.34171 20.0488 8.14645 19.8536Z'
        fill={arrowFillColor}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.5 12C19.5 12.2761 19.2761 12.5 19 12.5L16 12.5C15.7239 12.5 15.5 12.2761 15.5 12V9C15.5 8.72386 15.7239 8.5 16 8.5C16.2761 8.5 16.5 8.72386 16.5 9V10.7929L19.1464 8.14645C19.3417 7.95118 19.6583 7.95118 19.8536 8.14645C20.0488 8.34171 20.0488 8.65829 19.8536 8.85355L17.2071 11.5H19C19.2761 11.5 19.5 11.7239 19.5 12Z'
        fill={arrowFillColor}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.5 12C12.5 12.2761 12.2761 12.5 12 12.5H9C8.72386 12.5 8.5 12.2761 8.5 12C8.5 11.7239 8.72386 11.5 9 11.5H10.7929L8.14645 8.85355C7.95118 8.65829 7.95118 8.34171 8.14645 8.14645C8.34171 7.95118 8.65829 7.95118 8.85355 8.14645L11.5 10.7929V9C11.5 8.72386 11.7239 8.5 12 8.5C12.2761 8.5 12.5 8.72386 12.5 9V12Z'
        fill={arrowFillColor}
      />
    </svg>
  );
};
